import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { doc, Firestore, getDoc } from '@fido/firebase/firestore';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { userProfileConverter } from '../data/user-profile';

/**
 * Guard that ensures the user has completed their profile before accessing protected routes.
 * Redirects to /profile with returnUrl query param if profile is incomplete.
 *
 * Profile is considered complete when:
 * - firstName is set
 * - lastName is set
 */
export const profileCompleteGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const auth = inject(Auth);
  const firestore = inject(Firestore);

  const u = await firstValueFrom(user(auth));

  if (!u) {
    return router.createUrlTree(['/sign-in']);
  }

  const profileDoc = await getDoc(
    doc(firestore, `users/${u.uid}`).withConverter(userProfileConverter),
  );
  const profile = profileDoc.data();

  if (!profile?.firstName || !profile?.lastName) {
    const returnUrl = route.url.map((segment) => segment.path).join('/');
    return router.createUrlTree(['/profile'], {
      queryParams: { returnUrl: `/${returnUrl}` },
    });
  }

  return true;
};
